import fromPairs from 'lodash/fromPairs'
import toPairs from 'lodash/toPairs'

export const PREFIX = 'APP'
const app = PREFIX + '/'
export const INITIALIZING_APPLICATION = `${app}INITIALIZING_APPLICATION`
export const AUTHENTICATED = `${app}AUTHENTICATED`
export const SELECT_COMMUNITY = `${app}SELECT_COMMUNITY`
export const MEDIA_QUERY_SET = `${app}MEDIA_QUERY_SET`
export const SELECTED_COMMUNITY = `SELECTED_COMMUNITY`
export const COMMUNITY_SET_IN_LOCAL_STORAGE = `${app}COMMUNITY_SET_IN_LOCAL_STORAGE`
export const FETCH_RASA_TOKEN = `${app}FETCH_RASA_TOKEN`
export const CONTENT_INIT = `${app}CONTENT_INIT`
export const VIEW_INIT = `${app}VIEW_INIT`
export const URL_PARSED = `${app}URL_PARSED`
export const URL_PARAMS = `${app}URL_PARAMS`
export const UPDATE_URL_PARAMS = `${app}UPDATE_URL_PARAMS`
export const UPDATED = `${URL_PARAMS}_UPDATED`
export const FETCH_COMMUNITIES = 'FETCH_COMMUNITIES'
export const APP_ENTER_STARTED = 'APP_ENTER_STARTED'
// https://getbootstrap.com/docs/4.0/layout/overview/#responsive-breakpoints
export const BREAKPOINTS = {
  ExtraSmall: 576,
  Large: 1200,
  Medium: 992,
  Small: 768,
}

// utility method, but can't put into utils.
export const filterObject = (sourceObj: {}, filterObj: {}) => fromPairs(
  toPairs(sourceObj).filter(([key]) => Object.keys(filterObj).includes(key)),
)



// WEBPACK FOOTER //
// ./src/app/constants.ts